import React from 'react';
import { useTranslation } from 'react-i18next';
import { Star } from 'lucide-react';
import Reveal from './Reveal';

const DescriptorMarquee: React.FC = () => {
  const { t } = useTranslation();

  const words = [
    t('hero.subtitle'),
    t('menu.allYouCanEat'),
    t('menu.cuisine.japanese.name'),
    t('menu.cuisine.chinese.name'),
    t('menu.cuisine.european.name'),
    t('menu.cuisine.grill.name'),
    t('menu.cuisine.seafood.name'),
    t('menu.cuisine.desserts.name'),
    t('info.open7days'),
    t('about.freshness'),
    t('about.homemade')
  ];

  const track = [...words, ...words];

  return (
    <Reveal duration={0.5}>
      <div className="py-6 md:py-8 bg-luxury-black overflow-hidden border-y border-luxury-gold/30">
        <div className="flex animate-scroll-right-mobile md:animate-scroll-right whitespace-nowrap">
          {track.map((word, index) => (
            <span key={index} className="flex items-center gap-4 md:gap-6 mx-4 md:mx-6">
              <span className="font-display italic text-lg md:text-xl tracking-wide text-luxury-champagne/90">
                {word}
              </span>
              <Star size={10} className="text-luxury-gold fill-luxury-gold flex-shrink-0" />
            </span>
          ))}
        </div>
      </div>
    </Reveal>
  );
};

export default DescriptorMarquee;
